var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "last-wins-card", class: "last-wins-card--" + _vm.cardType },
    [
      _c("div", { staticClass: "user-info" }, [
        _c("div", { staticClass: "avatar-wrapper" }, [
          _vm.displayData.user
            ? _c("img", {
                staticClass: "avatar-img",
                attrs: {
                  loading: "lazy",
                  src: _vm.avatarUrl,
                  alt: "User Avatar",
                },
              })
            : _c("div", { staticClass: "avatar-placeholder" }),
          !_vm.isLg
            ? _c("div", { staticClass: "coefficient-badge" }, [
                _c("span", [_vm._v("x" + _vm._s(_vm.displayData.coefficient))]),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "user-details" }, [
          _c("span", { staticClass: "user-name" }, [
            _vm._v(_vm._s(_vm.displayData.username)),
          ]),
          _vm.isLg
            ? _c("div", { staticClass: "coefficient-badge" }, [
                _c("span", [_vm._v("x" + _vm._s(_vm.displayData.coefficient))]),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm.itemImgSrc
        ? _c("img", {
            staticClass: "item-img gun-mask",
            attrs: { loading: "lazy", src: _vm.itemImgSrc, alt: "Item" },
          })
        : _vm._e(),
      _c("div", { staticClass: "win-info" }, [
        _c(
          "div",
          { staticClass: "win-badge", class: "win-badge--" + _vm.cardType },
          [
            _c("i", { staticClass: "icon icon_coin-c" }),
            _c("span", [_vm._v(_vm._s(_vm.displayData.winAmount))]),
          ]
        ),
        _c("span", { staticClass: "item-name" }, [
          _vm._v(_vm._s(_vm.displayData.itemName)),
        ]),
      ]),
      _vm.cardType !== "normal"
        ? _c("img", {
            staticClass: "shadow-bg",
            attrs: {
              loading: "lazy",
              src: _vm.shadowImgSrc,
              alt: "Card Shadow",
            },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }